export enum AccountsPageProps {
  PAGE_TITLE = 'Accounts',
  ROWONE_CATEGORY1 = 'Revenue range',
  ROWONE_VALUE1 = '$100,000',
  ROWONE_CATEGORY2 = 'No.of products',
  ROWONE_VALUE2 = '120',
  ROWTWO_CATEGORY1 = 'Product type',
  ROWTWO_CATEGORY2 = 'Member',
  ROWTWO_VALUE1 = 'CPG',
  ROWTOW_VALUE2 = 'Alberta Food Processors Association',
  COMPANY_LOGO_ALT = 'companyLogo',
}

export enum TabsKeys {
  USER_DETAILS = 'user-details',
  PRICING = 'pricing',
}

export enum TabsLabels {
  USER_DETAILS = 'User details',
  PRICING = 'Plans',
}

export enum ButtonProps {
  ADD_USER = 'Add user',
  EDIT_LOGO = 'Update Logo',
}

export enum UserDetailsTableProps {
  DELETE_MODAL_HEADING = 'Do you want to delete the user account?',
  DELTE_MODAL_SUBHEADING = 'By deleting the user account, it will be permanently removed and you will not be able to retrieve it later.',
  EDIT_MODAL_HEADING = 'Do you want to edit the user account?',
}

export enum SearchProps {
  SEARCH_PLACEHOLDER = 'Search',
}

export enum customPaginationProps {
  ITEM_RENDER = 'itemRender',
}

export enum ItemRenderTypes {
  JUMP_NEXT = 'jump-next',
  JUMP_PREV = 'jump-prev',
  PAGE = 'page',
  PREV = 'prev',
  NEXT = 'next',
}

export enum ItemRenderButtons {
  JUMP_NEXT = '...',
  JUMP_PREV = '&lt; &lt;',
  PAGE = 'page',
  NEXT = '&gt;',
  PREV = '&lt;',
}
